import { IFiat } from './accounts.interfaces';
import { IFreeSpin } from './game.interfaces';
import { WALLET_CODE } from './wallet.interfaces';

export enum LuckyCellsType {
  POINTS_10 = 'points_10',
  POINTS_15 = 'points_15',
  POINTS_20 = 'points_20',
  FIAT_5 = 'fiat_5',
  BONUS_RECHARGE_50 = 'bonus_recharge_50',
  FREE_SPIN_10 = 'free_spin_10',
}
export interface LuckyCells {
  index: number;
  type: LuckyCellsType;
  probabilities: number;
  state: 'show' | 'hide';
  freespin?: IFreeSpin;
}
export interface LuckyCellsGame {
  _id?: string;
  createdAt?: number;
  user_id: string;
  game: Partial<LuckyCells>;
  wallet: WALLET_CODE;
  transaction_id?: string;
}
export enum LuckyCellsState {
  WAITING = 'waiting',
  READY = 'ready',
  PLAYING = 'playing',
  FINISHED = 'finished',
}
